import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectRelationRole} from '../models/project-relation-role';
import {ProjectRelationVw, ProjectRelation} from '../models/project-relation';
import {PageResponse} from '../models/page-response';
import {Company} from '../models/company';

export interface ProjectRelationService {
    list(refId: number): Observable<ProjectRelation[]>;
    createOther(refId: number, projectRelation: ProjectRelation): Observable<ProjectRelation>;
    createVw(refId: number, createVwProjectRelation: ProjectRelationVw): Observable<ProjectRelation>;
    updateOther(refId: number, projectRelation: ProjectRelation): Observable<ProjectRelation>
    updateVw(refId: number, projectRelation: ProjectRelationVw): Observable<ProjectRelation>
    delete(refId: number, id: number): Observable<void>;
    listMdmCompanies(search: string, page: number): Observable<PageResponse<Company>>;
    listCustomCompanies(search: string, page: number): Observable<PageResponse<Company>>;
    customCompanyByCompanyName(companyName: string): Observable<Company>;
    listRelationRoles(): Observable<ProjectRelationRole[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectRelationServiceImpl implements ProjectRelationService {
    protected http = inject(HttpClient);


    list(refId: number) {
        return this.http.get<ProjectRelation[]>(`/api/v1/project-references/${refId}/project-relations`)
    }

    createOther(refId: number, projectRelation: ProjectRelation) {
        return this.http.post<ProjectRelation>(`/api/v1/project-references/${refId}/project-relations/other`, projectRelation);
    }

    createVw(refId: number, createVwProjectRelation: ProjectRelationVw) {
        return this.http.post<ProjectRelation>(`/api/v1/project-references/${refId}/project-relations/vw`, createVwProjectRelation);
    }

    updateOther(refId: number, projectRelation: ProjectRelation) {
        return this.http.put<ProjectRelation>(`/api/v1/project-references/${refId}/project-relations/other/${projectRelation.id}`, projectRelation);
    }

    updateVw(refId: number, createVwProjectRelation: ProjectRelationVw) {
        return this.http.put<ProjectRelation>(`/api/v1/project-references/${refId}/project-relations/vw/${createVwProjectRelation.id}`, createVwProjectRelation);
    }

    delete(refId: number, id: number): Observable<void> {
        return this.http.delete<void>(`/api/v1/project-references/${refId}/project-relations/${id}`);
    }

    listMdmCompanies(search: string, page: number): Observable<PageResponse<Company>> {
        return this.http.get<PageResponse<Company>>('/api/v1/project-relations/mdm-companies', {
            params: {
                page: page.toString(),
                search
            }
        });
    }

    listCustomCompanies(search: string, page: number): Observable<PageResponse<Company>> {
        return this.http.get<PageResponse<Company>>('/api/v1/project-relations/custom-companies', {
            params: {
                page: page.toString(),
                search
            }
        });
    }

    customCompanyByCompanyName(companyName: string): Observable<Company> {
        return this.http.get<Company>('/api/v1/project-relations/custom-companies/by-name', {
            params: {
                companyName: companyName
            }
        })
    }

    listRelationRoles(): Observable<ProjectRelationRole[]> {
        return this.http.get<ProjectRelationRole[]>(`/api/v1/project-relations/roles`);
    }
}

